module.exports = __webpack_public_path__ + "static/media/banner-2.b90f19da.jpg";